// extracted by mini-css-extract-plugin
var _1 = "DragPlaceholderAbsolute_element__1f208";
var _2 = "DragPlaceholderAbsolute_group__26e27";
export { _1 as "element", _2 as "group" }
